import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey = 'signup-modal_submit_email_click-click';

/**
 * CTA click from Signup modal, which should lead to the signup flow
The parameter is for determine where the modal is. Right not it will be used for heavy gating on SEO test. #ft-streamlined-gating
 */
export function trackSignupModalSubmitEmailClickClick(
  customParameterToken: string = "''"
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { customParameterToken },
  });
}
